import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
  
);

export const plotService = {
  getAllProjects: async () => {
    try {
      const response = await api.get('/projects');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getProjectDetails: async (projectId) => {
    try {
      const response = await api.get(`/projects/${projectId}/details`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  createPlotInventory: async (plotData) => {
    try {
      const response = await api.post('/projects/inventory/add', plotData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getProjectPlots: async (projectId) => {
    try {
      const response = await api.get(`/projects/${projectId}/plots`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  updatePlotInventory: async (plotId, plotData) => {
    try {
      const response = await api.put(`/projects/inventory/${plotId}`, plotData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  deletePlotInventory: async (plotId) => {
    try {
      const response = await api.put(`/projects/inventory/${plotId}`, {
        isDeleted: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default plotService;